import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import '../ActionTwoHopProgressTable.css';
import DeviceTableCell from 'components/features/DeviceView/DeviceTable/DeviceTableCells/DeviceTableCell';

const ActionTwoHopProgressTableProgressCell = (props) => {
  const twoHopProgressDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopProgressDictionary?.[props.alignmentId]
  );

  return <DeviceTableCell center={true} displayString={twoHopProgressDictionary?.[props.rowKey]} />;
};

export default memo(ActionTwoHopProgressTableProgressCell);
